import { Injectable, signal } from '@angular/core';

/** Lifecycle macro-phase of a project. */
export type ProjectPhaseId = 'pre' | 'during' | 'post';

/**
 * Holds the phase currently selected in the project workspace stepper, so routed
 * sections can adapt to it (e.g. Finance hides Funding/Budget in the During phase).
 * The shell (project-module-view) is the single writer.
 */
@Injectable({ providedIn: 'root' })
export class ProjectPhaseService {
  readonly selectedPhase = signal<ProjectPhaseId>('pre');
}
